const methods = [
  { icon: "ri-wechat-pay-line", name: "微信支付", desc: "扫码即充，秒级到账", accent: "bg-accent-500" },
  { icon: "ri-alipay-line", name: "支付宝", desc: "快捷安全，实时到账", accent: "bg-primary-500" },
  { icon: "ri-bank-card-line", name: "银行卡", desc: "主流银行全覆盖", accent: "bg-secondary-500" },
  { icon: "ri-ticket-2-line", name: "点券卡", desc: "官方充值卡兑换", accent: "bg-primary-500" },
];

const steps = [
  { num: "01", title: "选择金额", desc: "进入充值中心，选择充值面额与点券数量。" },
  { num: "02", title: "选择方式", desc: "任选微信、支付宝、银行卡等官方支付方式。" },
  { num: "03", title: "确认到账", desc: "支付完成后点券实时到账，可在账户中查看明细。" },
];

export default function Recharge() {
  return (
    <section id="recharge" className="relative bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <span className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-widest text-primary-400">
              <i className="ri-bank-card-2-line" aria-hidden="true"></i>
              充值服务
            </span>
            <h2 className="mt-3 font-heading text-3xl md:text-5xl text-foreground-50">安全便捷，充值更安心</h2>
            <p className="mt-4 text-foreground-300">
              官方充值渠道，多种支付方式，实时到账有保障。充值明细清晰可查，让你的每一分投入都清清楚楚。
            </p>

            <ul className="mt-7 space-y-4">
              {steps.map((step) => (
                <li key={step.num} className="flex gap-4">
                  <span className="font-heading text-2xl text-accent-400">{step.num}</span>
                  <div>
                    <h3 className="font-heading text-base text-foreground-50">{step.title}</h3>
                    <p className="mt-1 text-sm text-foreground-400">{step.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-2 gap-4 content-start">
            {methods.map((m) => (
              <article
                key={m.name}
                className="flex items-center gap-4 rounded-xl border border-background-200/70 bg-background-100 p-5 transition-colors hover:border-primary-400/50"
              >
                <span className={`flex h-12 w-12 items-center justify-center rounded-xl ${m.accent} text-background-950`}>
                  <i className={`${m.icon} text-2xl`} aria-hidden="true"></i>
                </span>
                <div>
                  <h3 className="font-heading text-base text-foreground-50">{m.name}</h3>
                  <p className="text-sm text-foreground-400">{m.desc}</p>
                </div>
              </article>
            ))}

            <div className="rounded-xl border border-accent-400/40 bg-accent-500/10 p-5 sm:col-span-2">
              <h3 className="flex items-center gap-2 font-heading text-base text-foreground-50">
                <i className="ri-shield-check-line text-accent-400" aria-hidden="true"></i>
                充值保障承诺
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-300">
                所有充值均通过官方渠道完成，资金与信息多重加密保护。若因平台原因未到账，我们将全额原路退回并优先处理，客服 7×12 小时在线响应。
              </p>
              <a
                href="#contact"
                className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-accent-300 hover:text-accent-200 transition-colors whitespace-nowrap"
              >
                遇到问题？联系客服协助
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}